import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=4097e435&scoped=true&lang=html"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
import style0 from "./Checkbox.scss?vue&type=style&index=0&id=4097e435&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097e435",
  null
  
)

export default component.exports